import React, { useState, useEffect } from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import Button from '../button/Button';
import { regexByPhoneNumber, regexByEmail } from '../../../utils/RegexHelper';
import ErrorMsg from '../error/ErrorMsg';

const Question2 = props => {
  const [phoneHasError, setPhoneHasError] = useState(false);
  const [emailHasError, setEmailHasError] = useState(false);
  const [confirmEmailHasError, setConfirmEmailHasError] = useState(false);
  const [confirmEmailMatchHasError, setConfirmEmaiMatchlHasError] = useState(false);
  const [secondaryEmailEntered, setSecondaryEmailEntered] = useState(false);

  useEffect(
    () => {
      if (!secondaryEmailEntered) return;
      setConfirmEmaiMatchlHasError(
        validateSecondaryEmailAddress(props.emailAddress, props.repeatEmail)
      );
    },
    [props.repeatEmail, props.emailAddress, secondaryEmailEntered]
  );

  const validateSecondaryEmailAddress = (address1, address2) =>
    address1 !== null && address1 !== address2;

  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        <h3 className={`${styles.pageTitle}`}>What are your contact details?</h3>
        <div className={`mt-5`}>
          <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
            <label
              for={`notifiersContactNumber`}
              className={`nsw-form-label ${styles.nswFormLabel}`}
            >
              Phone number
            </label>
            <input
              type="text"
              inputmode="decimal"
              id={'notifiersContactNumber'}
              name={'notifiersContactNumber'}
              className={`nsw-form-input ${styles.nswFormInput}`}
              maxLength={'20'}
              value={
                props.contactNumber && props.contactNumber.length > 0
                  ? props.contactNumber
                  : undefined
              }
              onChange={event => {
                setPhoneHasError(regexByPhoneNumber(event.target.value));
                props.setContactNumber(event.target.value);
              }}
              aria-describedby={phoneHasError ? 'notifiersContactNumberErrorMessage' : undefined}
              aria-invalid={`${phoneHasError ? 'true' : 'false'}`}
            />
          </div>

          {phoneHasError ? (
            <div className={`row`}>
              <div className={`col-12 ${styles.errorContainer1}`}>
                <ErrorMsg
                  id={'deceasedEmailAddressErrorMessage'}
                  type={'error'}
                  description={'The contact number is invalid.'}
                />
              </div>
            </div>
          ) : null}
        </div>

        <div className={``}>
          <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
            <h4 className={styles.nswFormLabel}>Email address</h4>
            <input
              id={'notifiersEmailAddress'}
              name={'notifiersEmailAddress'}
              className={`nsw-form-input ${styles.nswFormInput}`}
              value={
                props.emailAddress && props.emailAddress.length > 0 ? props.emailAddress : undefined
              }
              onChange={event => {
                setEmailHasError(regexByEmail(event.target.value));
                props.setEmailAddress(event.target.value);
              }}
              onBlur={() => {
                props.setEmailEntered(true);
              }}
              aria-describedby={emailHasError ? 'notifiersEmailAddressErrorMessage' : undefined}
              aria-invalid={`${emailHasError ? 'true' : 'false'}`}
            />
          </div>

          {emailHasError ? (
            <div className={`row`}>
              <div className={`col-12 ${styles.errorContainer1}`}>
                <ErrorMsg
                  id={'deceasedEmailAddressErrorMessage'}
                  type={'error'}
                  description={'The email address is invalid.'}
                />
              </div>
            </div>
          ) : null}
        </div>

        <div className={``}>
          <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
            <h4 className={styles.nswFormLabel}>Confirm email address</h4>
            <input
              id={'notifiersConfirmEmailAddress'}
              name={'notifiersConfirmEmailAddress'}
              className={`nsw-form-input ${styles.nswFormInput}`}
              value={
                props.repeatEmail && props.repeatEmail.length > 0 ? props.repeatEmail : undefined
              }
              onChange={event => {
                setConfirmEmailHasError(regexByEmail(event.target.value));
                props.setRepeatEmail(event.target.value);
              }}
              onBlur={() => {
                setSecondaryEmailEntered(true);
              }}
              aria-describedby={
                confirmEmailMatchHasError || confirmEmailHasError
                  ? 'notifiersEmailAddressErrorMessage'
                  : undefined
              }
              aria-invalid={`${confirmEmailMatchHasError || confirmEmailHasError
                ? 'true'
                : 'false'}`}
            />
          </div>

          {confirmEmailHasError ? (
            <div className={`row`}>
              <div className={`col-12 ${styles.errorContainer1}`}>
                <ErrorMsg
                  id={'deceasedEmailAddressErrorMessage'}
                  type={'error'}
                  description={'The email address is invalid.'}
                />
              </div>
            </div>
          ) : null}
          {confirmEmailMatchHasError ? (
            <div className={`row`}>
              <div className={`col-12`}>
                <div className={`${styles.errorContainer}`}>
                  <ErrorMsg
                    id={'notifiersConfirmEmailAddressErrorMessage'}
                    type={'error'}
                    description={'The email addresses do not match.'}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <div className={styles.btnWrap}>
          <Button
            disabled={
              phoneHasError ||
              confirmEmailHasError ||
              emailHasError ||
              confirmEmailMatchHasError ||
              !props.contactNumber ||
              !props.emailAddress ||
              !props.repeatEmail
            }
            onClick={() => {
              props.setCurrentQuestion(3);
            }}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Question2;
